import { Permission } from '@campx-org/shared'
import AdminRouteGuard from 'components/AdminRouteGuard'
import { EvaluationPercentageDifferenceReport, ScrutinyReport } from 'pages'
import { lazy } from 'react'

const BookletEvalDiffReport = lazy(
  () => import('pages/Admin/BookletEvalDiffReport'),
)

export const individualRoutes = [
  {
    path: 'subject-bundle-scrutiny-report',
    element: <ScrutinyReport />,
    permissionKey: Permission.CAN_DASHBOARD_VIEW,
  },
  {
    path: 'subject-bundle-evaluation-difference-report',
    element: <EvaluationPercentageDifferenceReport />,
    permissionKey: Permission.CAN_DASHBOARD_VIEW,
  },
  {
    path: 'booklet-eval-diff-report',
    element: (
      <AdminRouteGuard>
        <BookletEvalDiffReport />
      </AdminRouteGuard>
    ),
    permissionKey: Permission.CAN_DASHBOARD_VIEW,
  },
]
